<script>
import Base from '@backend/Base.vue';
import BoConfig from '@config/BoConfig.js';
import BOGen from '@helper/BOGen.js';

export default {
  extends: Base,
  data(){
    return {
      Name:"AdditionalFacility",
      PageName: "Additional Facility",
      ObjectName: "Additional Facility",
      input: {},
      WithLimit: true,
      isDocumentationAvailable: false,
      filter: {},
      dummyRequestData: [
        {
          afNo: 'FAF-2022-00001',
          reqDate: '2022-03-02',
          reqFor: 'Facility Lend',
          fullName: 'Ahmad Wiharja',
          ipin: '321421',
          cwid: 'JXSWZ',
          division: 'Software Developer',
          department: 'Information Technology',
          posTitle: '',
          approval: 'p'
        },
        {
          afNo: 'FAF-2022-00002',
          reqDate: '2022-03-02',
          reqFor: 'Additional Facility',
          fullName: 'Ahmad Wiharja',
          ipin: '321421',
          cwid: 'JXSWZ',
          division: 'Software Developer',
          department: 'Information Technology',
          posTitle: '',
          approval: 'A'
        },
        {
          afNo: 'FAF-2022-00003',
          reqDate: '2022-03-02',
          reqFor: 'Additional Facility',
          fullName: 'Ahmad Wiharja',
          ipin: '321421',
          cwid: 'JXSWZ',
          division: 'Software Developer',
          department: 'Information Technology',
          posTitle: '',
          approval: 'R'
        },
      ],
      detailTab: 'it'
    }
  },
  computed:{
    dataSrc() {
      return this.dummyRequestData.find(el => el.afNo == this.$route.params.id)
    },
  },
  mounted(){
    this.checkAccessMenu(this.$route.meta.group)
    this.$set(this.$root, 'page', this)
    if(this.$route.params.id){
      this.refreshData()
    }
    
    this.refreshData()
    this.updateAdditionalRejected()
  },
  methods:{
    updateAdditionalRejected(){
      BOGen.apirest('/UpdateAdditionalRejected', { cwid: this.user.cwid }, (err, resp) => {
        if(err) return console.error(err);
      }, "POST")
    }
  },
  watch:{}
}
</script>

<template>
  <div class="container-fluid">
    <div class="row mt-4" v-if="!isDocumentationAvailable">
      <div class="col-md-12">
        <div class="alert alert-warning w-100" role="alert">
          <b class="fw-500">Important Notice!</b> Belum ada user dengan level "<strong class="fw-500">Documentation</strong>". Silakan hubungi Administrator untuk menambahkannya.
        </div>
      </div>
    </div>

    <div class="row page-titles align-items-center">
      <div class="col-md-5">
        <h4 class="text-themecolor">{{PageName}}</h4>
      </div>
      <div class="col-md-7 tr" v-if="isDocumentationAvailable">
        <div class="btn-group">
          <router-link :to="{name:'AdditionalFacilityInit'}" class="btn btn-outline-success" v-tooltip="'Add '+ObjectName">
            <i class="fa fa-plus"></i><span> Add</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="card" v-if="!$route.params.id">
      <div class="card-body">
        <VForm @resp.prevent>
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-2 ml-auto">
              <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit"></Select2>
            </div>
            <div class="col-sm-auto">
              <div class="d-flex">
                <div class="has-feedback has-feedback-left">
                  <input type="search" v-model="filter.search" @keyup.enter="search" class="form-control" placeholder="Type and hit Enter">
                  <div class="form-control-feedback">
                    <i class="icon-search4 text-size-base text-muted"></i>
                  </div>
                </div>
                <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm ml-2">Reset</button>
              </div>
            </div>
          </div>
        </VForm>
      </div>
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-hover table-bordered mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>AF No.</th>
              <th>Req. Date</th>
              <th>Department</th>
              <th>Req. By</th>
              <th>Employee Name</th>
              <th>CWID</th>
              <th>Req. For</th>
              <th>Status</th>              
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, k) in data.data" :key="k">
              <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
              <td>{{ v.ai_request_number }}</td>
              <td>{{ moment(v.ai_request_date).format('DD MMM YYYY') }}</td>
              <td>{{ v.ai_department || '-' }}</td>              
              <td>{{ v.request_by }}</td>
              <td>
                <div>{{ v.employeename || '-' }}</div>
                <small>{{ v.posTitle }}</small>
              </td>
              <td>{{ v.ai_cwid || '-' }}</td>
              <td>{{ v.request_for }}</td>              
              <td>
                <StatusLabel :obj="v"></StatusLabel>
              </td>
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>
